import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { loadableReady } from '@loadable/component';
import { Provider as PAGE_CONTEXT } from '../../../../contexts/PageContext';
import PAGE_COMPONENT from './MasterFeed';

loadableReady(() => {
    const root = document.getElementById('root');
    hydrateRoot(
        root,
        <PAGE_CONTEXT PAGE_PROPS={window.__GLOBAL_PAGE_PROPS__.PAGE_PROPS}>
            <PAGE_COMPONENT {...window.__GLOBAL_PAGE_PROPS__} />
        </PAGE_CONTEXT>
    );
});
